module.exports = __webpack_public_path__ + "static/media/YM79_1.dcc11da5.jpg";